import { render, staticRenderFns } from "./TimelineCommentPost.vue?vue&type=template&id=6bed86b0&scoped=true&"
import script from "./TimelineCommentPost.vue?vue&type=script&lang=js&"
export * from "./TimelineCommentPost.vue?vue&type=script&lang=js&"
import style0 from "./TimelineCommentPost.vue?vue&type=style&index=0&id=6bed86b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bed86b0",
  null
  
)

export default component.exports